import { IconButton, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import ActEdit from '../../../canopy-ui-components/components/Icons/ActEdit';
import * as ga from '../../../canopy-ui-components/google-analytics';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import EditMappingModal from './EditMappingsModal';

interface Props extends PageComponentProps<any> {
    userId: number[];
    data: any[];
    globalProps: GlobalProps;
    refreshData: () => void;
}

export function EditMappingsAction(props: any) {
    const currentColors = useCurrentColors();
    const [showModal, setShowModal] = useState(false);
    const {
        globalProps: { t },
    } = props;
    const handleClick = async () => {
        ga.event({
            action: `${window.location.pathname.replace(
                '//g/',
                ''
            )} > Clicked Manage File Tags`,
            fileName: props?.data?.[0]?.original?.fileName,
        });
        setShowModal(true);
    };

    return (
        <>
            <Tooltip
                aria-label="edit-file-details"
                label={t('ui.mm.tooltip.edit-mapping')}
                placement="bottom-start"
                hasArrow>
                <IconButton
                    background="transparent"
                    cursor="pointer"
                    border="none"
                    width="20px !important"
                    minWidth="20px !important"
                    height="20px !important"
                    icon={<ActEdit />}
                    aria-label="edit-file-details"
                    data-test="edit-file-details"
                    backgroundColor="transparent"
                    color={currentColors.brand['300']}
                    variant="ghost"
                    _hover={{
                        backgroundColor: 'transparent',
                    }}
                    _focus={{
                        border: '0px',
                        backgroundColor: 'transparent',
                        outline: 'none',
                    }}
                    _active={{
                        border: '0px',
                    }}
                    onClick={handleClick}></IconButton>
            </Tooltip>
            {showModal && (
                <EditMappingModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    {...props}></EditMappingModal>
            )}
        </>
    );
}

export default EditMappingsAction;
